import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="employer-onboarding-config"
export default class extends Controller {
  static targets = [
    'allowancesStepDisplay',
    'coverageStartDateStepDisplay',
    'payrollStepDisplay',
  ]

  declare readonly allowancesStepDisplayTarget: HTMLElement
  declare readonly coverageStartDateStepDisplayTarget: HTMLElement
  declare readonly payrollStepDisplayTarget: HTMLElement

  connect () {
    this.element.querySelectorAll<HTMLInputElement>('input[type="checkbox"]').forEach((checkboxEl: HTMLInputElement) => {
      checkboxEl.addEventListener('change', (e: Event) => {
        const inputEl = e.target as HTMLInputElement
        const targetVar = inputEl.getAttribute('data-employer-onboarding-config-display-target-value')
        const targetEl = this.targets.find(targetVar || '')
        if (targetEl) {
          const skippedIndicatorEl: HTMLElement | null = targetEl.querySelector('.skipped-indicator')
          if (inputEl.checked) {
            skippedIndicatorEl?.classList.remove('hidden')
            skippedIndicatorEl?.classList.add('flex')
          } else {
            skippedIndicatorEl?.classList.add('hidden')
            skippedIndicatorEl?.classList.remove('flex')
          }
        }
      })
    })
  }
}
